// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE

import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined' || import.meta.env.SSR;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Reservation = (await import('./pages/Reservation')).Reservation;
    Components.Delivery = (await import('./pages/Delivery')).Delivery;
    Components.ClearCallback = (await import('./pages/ClearCallback')).ClearCallback;
    Components.ClearVerification = (await import('./pages/ClearVerification')).ClearVerification;
    Components.ClearCallbackV2 = (await import('./pages/ClearCallbackV2')).ClearCallbackV2;
    Components.SelfDropoff = (await import('./pages/SelfDropoff')).SelfDropoff;
    Components.ReservationDetails = (await import('./pages/ReservationDetails')).ReservationDetails;
    Components.ManageReservation = (await import('./pages/ManageReservation')).ManageReservation;
    Components.ManageReservationV2 = (await import('./pages/ManageReservationV2')).ManageReservationV2;
    Components.CancelReservation = (await import('./pages/CancelReservation')).CancelReservation;
    Components.Product = (await import('./pages/Product')).Product;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  reservation: {
    name: 'Reservation',
    componentName: 'Reservation',
    chunk: () => import('./pages/Reservation'),
    get component() {
      if (ssr) return serverPages.Reservation;
      if (currentRouteName === 'Reservation') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Reservation })));
    },
    path: '/:context?/p/rental/reservations/:slug?/:itemId',
    channel: null
  },
  delivery: {
    name: 'Delivery',
    componentName: 'Delivery',
    chunk: () => import('./pages/Delivery'),
    get component() {
      if (ssr) return serverPages.Delivery;
      if (currentRouteName === 'Delivery') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Delivery })));
    },
    path: '/:context?/p/rental/delivery/:slug?/:itemId',
    channel: null
  },
  clearCallback: {
    name: 'ClearCallback',
    componentName: 'ClearCallback',
    chunk: () => import('./pages/ClearCallback'),
    get component() {
      if (ssr) return serverPages.ClearCallback;
      if (currentRouteName === 'ClearCallback') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallback })));
    },
    path: '/:context?/rental/clear-verification/callback',
    channel: null
  },
  clearVerification: {
    name: 'ClearVerification',
    componentName: 'ClearVerification',
    chunk: () => import('./pages/ClearVerification'),
    get component() {
      if (ssr) return serverPages.ClearVerification;
      if (currentRouteName === 'ClearVerification') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearVerification })));
    },
    path: '/:context?/rental/clear-verification/:clearState',
    channel: null
  },
  clearCallbackV2: {
    name: 'ClearCallbackV2',
    componentName: 'ClearCallbackV2',
    chunk: () => import('./pages/ClearCallbackV2'),
    get component() {
      if (ssr) return serverPages.ClearCallbackV2;
      if (currentRouteName === 'ClearCallbackV2') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallbackV2 })));
    },
    path: '/:context?/rental/clear-verification/v2/callback/:uuid',
    channel: null
  },
  selfDropoff: {
    name: 'SelfDropoff',
    componentName: 'SelfDropoff',
    chunk: () => import('./pages/SelfDropoff'),
    get component() {
      if (ssr) return serverPages.SelfDropoff;
      if (currentRouteName === 'SelfDropoff') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SelfDropoff })));
    },
    path: '/:context?/rental/self-dropoff/:storeId',
    channel: null
  },
  reservationDetails: { // TODO: Remove once transitioned off
    name: 'ReservationDetails',
    componentName: 'ReservationDetails',
    chunk: () => import('./pages/ReservationDetails'),
    get component() {
      if (ssr) return serverPages.ReservationDetails;
      if (currentRouteName === 'ReservationDetails') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReservationDetails })));
    },
    path: '/:context?/p/rental/reservationDetails',
    channel: null
  },
  manageReservation: {
    name: 'ManageReservation',
    componentName: 'ManageReservation',
    chunk: () => import('./pages/ManageReservation'),
    get component() {
      if (ssr) return serverPages.ManageReservation;
      if (currentRouteName === 'ManageReservation') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ManageReservation })));
    },
    path: '/:context?/rental/manage-reservation/:uuid/:reservationId/:storeId',
    channel: null
  },
  manageReservationV2: {
    name: 'ManageReservationV2',
    componentName: 'ManageReservationV2',
    chunk: () => import('./pages/ManageReservationV2'),
    get component() {
      if (ssr) return serverPages.ManageReservationV2;
      if (currentRouteName === 'ManageReservationV2') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ManageReservationV2 })));
    },
    path: '/:context?/rental/manage-reservation/v2/:uuid/:reservationId/:storeId',
    channel: null
  },
  cancelReservation: {
    name: 'CancelReservation',
    componentName: 'CancelReservation',
    chunk: () => import('./pages/CancelReservation'),
    get component() {
      if (ssr) return serverPages.CancelReservation;
      if (currentRouteName === 'CancelReservation') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CancelReservation })));
    },
    path: '/:context?/rental/cancel-reservation/:cancellationId/:reservationNumber',
    channel: null
  },
  product: {
    name: 'Product',
    componentName: 'Product',
    chunk: () => import('./pages/Product'),
    get component() {
      if (ssr) return serverPages.Product;
      if (currentRouteName === 'Product') return currentRouteComponent;
      return generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Product })));
    },
    path: '/:context?/p/rental/:slug?/:itemId',
    channel: null
  },

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
